/**
 * @description Exibe a versão do aplicativo e o nome do aplicativo
 * @module VersionViewer
 * @since Agosto 2025
 */

import React from "react";
import { Stack, Typography } from "@mui/material";

const VersionViewer: React.FC = () => {
  const version = import.meta.env.VITE_VERSION_TEXT;
  const app = import.meta.env.VITE_PROJ;
  return (
    <Stack p={2} justifyContent="center" alignItems="center" flexGrow={1}>
      <Typography fontSize={14} color="neutral600.main">
        {version}
      </Typography>
    </Stack>
  );
};

export { VersionViewer };
